import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { pageData } from './data';
import { ChevronDownIcon } from 'lucide-react';
import { cn } from '../utils';
export function FAQ() {
  const {
    faq
  } = pageData;
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <h2 className="text-3xl md:text-4xl text-center mb-12" data-id="element-60">
          {faq.heading}
        </h2>

        <div className="space-y-4" data-id="element-61">
          {faq.items.map((item, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className="bg-slate-850 border border-slate-800 rounded-xl overflow-hidden" data-id="element-62">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-63">
                  <span className="font-bold text-white pr-8" data-id="element-64">
                    {item.question}
                  </span>
                  <ChevronDownIcon className={cn('w-5 h-5 text-slate-500 shrink-0 transition-transform duration-300', isOpen && 'rotate-180 text-gold-500')} data-id="element-65" />
                </button>

                <AnimatePresence initial={false} data-id="element-66">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-67">
                      <div className="px-6 pb-5 text-slate-400 leading-relaxed border-t border-slate-800/50 pt-4" data-id="element-68">
                        {item.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}